import { useSelector } from "react-redux";

import styles from "./loader.module.scss";

const LoaderComponent = () => {
  const isLoading = useSelector((state) => state.common.isLoading);

  return (
    <div id="loaderMain"
      className={`${styles.loader} ${isLoading ? styles["show-spinner"] : ""}`} 
    />
  );
};

export default LoaderComponent;
